export const companyAreasPT = [
    { area: 'Agropecuária', cnae: 'Agricultura, pecuária, pesca' },
    { area: 'Indústria', cnae: 'Transformação, construção, mineração' },
    { area: 'Comércio', cnae: 'Atacado e varejo' },
    { area: 'Serviços', cnae: 'Serviços em geral' },
    { area: 'Transporte', cnae: 'Logística e transporte' },
    { area: 'Saúde', cnae: 'Serviços médicos e hospitalares' },
    { area: 'Educação', cnae: 'Ensino e Treinamento' },
    { area: 'Tecnologia', cnae: 'TI e telecomunicações' },
    { area: 'Financeiro', cnae: 'Bancos, seguros, investimentos' },
    { area: 'Turismo', cnae: 'Hotelaria e entretenimento' },
    { area: 'Outros', cnae: 'Demais atividades' }
  ]

export const companyAreasEN = []